import { JsonProperty, JsonObject } from 'typescript-json-serializer';
import { LmCurrent } from './lm-current.model';

@JsonObject()
export class LmStationGroup {
  @JsonProperty('Id') id: string;
  @JsonProperty('Name') name: string;
  @JsonProperty('StationCount') stationCount: number;
  @JsonProperty('MaxCurrent') maxCurrent: number;
  @JsonProperty('AvailableCurrent') availableCurrent: LmCurrent;
}
